const h = {
  title: 'SmallStep',
  languageText: 'English',
  subTitle: 'App Globalization Service Provider',
  lTitle: 'Open and pragmatic',
  cTitle: 'User-oriented',
  rTitle: 'Global perspective',
  mode1: 'About Us',
  mode2: 'Products',
  mode4: 'Contact Us',
  p1:
    'Founded in July 2019, Smallstep Technology specializes in app internationalization, mobile advertising, and monetization, delivering high-quality products and services to users worldwide. Our products span various regions, including Hong Kong, Macao, Taiwan, Southeast Asia, Europe, and the Americas, with a user base exceeding 50 million.',
  p2:
    'We remain committed to our mission, engaging users with a pragmatic approach. With a keen market sense and foresight into industry trends, we continuously innovate and refine our offerings. Our goal is to provide exceptional products and services to users around the globe.',
  desc1: 'Extensive experience in overseas products',
  desc2: 'A creative and youthful team',
  desc3: 'Extensive channel resources',
  desc4: 'Focus on user experience and employee development',
  benefitsTitle1: 'Life insurance',
  benefitsTitle2: 'Employee benefits',
  benefitsTitle3: 'Recreational activities',
  benefits1Desc1: 'Flexible working hours',
  benefits1Desc2: 'Weekends off',
  benefits1Desc3: 'Social insurance and housing fund',
  benefits1Desc4: 'Annual health check-up',
  benefits2Desc1: 'Year-end bonus',
  benefits2Desc2: 'Project bonuses',
  benefits2Desc3: 'Salary adjustment opportunities',
  benefits2Desc4: 'Paid annual leave',
  benefits3Desc1: 'Snacks and afternoon tea',
  benefits3Desc2: 'Annual company trip',
  benefits3Desc3: 'Regular team-building activities',
  benefits3Desc4: 'Holiday benefits and birthday gifts',
  usTitle1: 'Address',
  usTitle2: 'Transportation options',
  usTitle3: 'Email',
  usDesc1: 'X1301-G6441, 1st Building, 106 Fengze E Rd, Nansha District, Guangzhou City, Guangdong Province, China',
  usDesc1Line1: 'X1301-G6441, 1st Building',
  usDesc1Line2: '106 Fengze E Rd, Nansha District, Guangzhou City',
  usDesc1Line3: 'Guangdong Province, China',
  usDesc2: 'Exit E/F of Changgang Station, Metro Line 2/8.',
  usDesc3: 'xiaobuinfo2019@gmail.com',
  home: 'home',
  policy: 'Privacy Policy',
  service: 'Terms Of Service',
  beian1: 'Filing Number: Yue ICP No. 19148330',
  beian2: 'Guangzhou Smallstep Information Technology Co., Ltd.'
};

export default h;
